<template>
	<div class="contents-wrap">
		<div class="result">
			<transition name="slide-fade">
				<div class="answer-wrap">
					<div class="answer-title">
						★熟睡度70％
						<div class="text"> 隠れ睡眠不足に注意！</div>
					</div>
					<div class="answer-body">
						<p>十分に睡眠がとれていると思われるかもしれませんが、もう一度、「睡眠環境」をチェックしてみましょう。「寝室」では、温度（夏：25～28℃、冬：16～20℃）、湿度（夏：40～60％、冬：50％以上）をキープするようにして、光（0.3lux：晴れた日の月明り程度）、音（40㏈以下：図書館や昼の静かな住宅街）に注意しましょう。「寝具」では、それぞれの条件にあった寝具を選びましょう。（掛けふとん：温かさ・さわやかさ・軽さ・フィット感等、敷ふとん：極端に沈み込まない・体の凸部分の圧迫を和らげる・さわやかさ等、枕：自分に合った高さ・好みの硬さ等）</p>
						<div class="sub-cts"><h2>★さらにぐっすり眠るためには？</h2>
							<p>
								あなたは、毎日ゆっくりお風呂に入っていますか？入浴は、睡眠の質をぐっと高めてくれます。40℃前後のぬるめのお湯に15〜20分ほど浸かってリラックスしましょう。また、ストレスは睡眠の大敵です。ストレスを溜め込みすぎないよう、こまめな休息や気分転換を心がけてみてください。</p>
						</div>
						<div class="sub-cts">
							<h2>▼こちらもCHECK</h2>
							<ul>
								<li><a href="https://xn--z8js3azm.com/beauty/17">コーヒー以外も要注意！寝付きを邪魔する「カフェイン」を含む飲み物リスト</a></li>
							</ul>
						</div>
					</div>
					<div class="btn-area">
						<button @click="next(0)" class="btnReset">スタートに戻る</button>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ResultCts02',
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>
